import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockService = {
    getStockList,
    getAllStockList,
    getDetailList,
    getAllDetailList,
    getStockValuationReport,
    getAllStockValuationReport,
    exportStockBalanceExcel,
    exportStockValuationExcel
};
function getAllDetailList(searchParams) {

    let url = '/auth/stock-balances-detail-summary?';
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.issueNo) {
        url += '&issueNo=' + searchParams.issueNo;
    }
    if (searchParams.type) {
        url += '&type=' + searchParams.type;
    }
    if (searchParams.productId) {
        url += '&productId=' + searchParams.productId;
    }
    if (searchParams.warehouseId) {
        url += '&warehouseId=' + searchParams.warehouseId;
    }
    return axios.get(url);
}

function getStockList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.balanceFlag) {
        params["balanceFlag"] = searchParams.balanceFlag;
    }
    return axios.get("/auth/stock-balances", { params });
}

function getAllStockList(searchParams) {
    let params = {
        sort: "warehouseName,asc"
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.balanceFlag) {
        params["balanceFlag"] = searchParams.balanceFlag;
    }
    return axios.get("/auth/stock-balances", { params });
}
function getDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.productId) {
        params["productId"] = searchParams.productId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    return axios.get("/auth/stock-balances-detail-summary/", { params });
}
function getStockValuationReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    return axios.get("/auth/stock-valuation-report", { params });
}

function getAllStockValuationReport(searchParams) {
    let params = {
    };

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    return axios.get("/auth/stock-valuation-report", { params });
}

function exportStockBalanceExcel(searchParams) {
    let params = {
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.balanceFlag) {
        params["balanceFlag"] = searchParams.balanceFlag;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-balance-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function exportStockValuationExcel(searchParams) {
    let params = {
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-valuation-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}